import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
<h1>Eze Chinedu David</h1>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon" data-aos="flip-left" data-aos-delay="100">
            <a href="https://www.linkedin.com/in/david-chinedu-0429a2248"><img src={navIcon1} alt="Nav-icon" /></a>
                <a href="https://www.facebook.com/profile.php?id=100087269012268"><img src={navIcon2} alt="nav-icon" /></a>
                <a href="https://instagram.com/d_a_v_e_1_0_1?igshid=YzAwZjE1ZTI0Zg=="><img src={navIcon3} alt="icon" /></a>
            </div>
            <p>davidchinedu 2024</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}